<template>
  <SysDialog
    v-model="dialog_ativo"
    :titulo="props.titulo"
    :largura="props.largura || 400"
    content-class="bra-5"
    ocultar-acoes
  >
    <template #ativador>
      <slot name="ativador" :callback="() => dialog_ativo = !dialog_ativo"></slot>
    </template>

    <div class="mr-2">
      <slot>
        {{ props.texto }}
      </slot>

      <div class="mt-5 d-flex align-center justify-space-between">
        <v-btn
          class="text-transform-none font-weight-regular w-50-porcento bra-8"
          outlined
          color="#013254"
          @click="dialog_ativo = false"
        >
          {{ props.texto_btn_secundario }}
        </v-btn>

        <v-btn
          class="text-transform-none font-weight-regular ml-3 w-50-porcento bra-8"
          dark
          color="#013254"
          @click="() => $emit('click:btn-principal', {})"
        >
          {{ props.texto_btn_principal }}
        </v-btn>
      </div>
    </div>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";

const dialog_ativo = ref(false);

const props = defineProps({
  titulo: String,
  texto: String,
  texto_btn_principal: String,
  texto_btn_secundario: String,
  largura: Number,
});

const emit = defineEmits(['click:btn-principal']);
</script>
